import template from './birthday_report.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportBirthdayViewModel
{
	constructor(page)
	{
		let first_day = moment().format("YYYY-MM-01");
		let last_day = moment().format("YYYY-MM-") + moment().daysInMonth();

		this.page = page;
		this.employee_birthdays = ko.observableArray();
		this.loader = ko.observable(false);
		this.date_start = ko.observable(new Date(first_day).toJSON().slice(0, 10));
		this.date_end = ko.observable(new Date(last_day).toJSON().slice(0, 10));

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.date_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);
			

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, "YYYY-MM-DD", true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.date_end(month_end);

				this.page.updateData();
			}, 500);
		});

		this.date_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout) 
				clearTimeout(this.end_date_timeout);
			

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, "YYYY-MM-DD", true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.date_start(), "YYYY-MM-DD", true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({
							type: 'error',
							title: tr('Invalid Date Range'),
							message: tr('End date cannot be before start date')
						});
						return;
					}
					this.page.updateData();
				}
			}, 1000);
		});
	}

	show_birthdays_setup_help()
	{
		Grape.dialog.open('UpcomingBirthdaysHelp', {});
	}

	async download_clicked()
	{
		// Get the table and clone it to avoid modifying the original
		let table = document.getElementById('birthday_report');
		let tableClone = table.cloneNode(true);
		
		// Remove rows with ps-no-export class
		let noExportRows = tableClone.querySelectorAll('.ps-no-export');
		noExportRows.forEach(row => row.remove());
		
		let csv_string = await Utils.table_to_csv(tableClone);
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;
		
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');
	
		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'birthday_report.csv');
	
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	back_to_top()
	{
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}
}

class ReportBirthdayPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportBirthdayViewModel(this);
		window.current_page_title(tr('Upcoming Birthdays'));
	}

	async updateData()
	{
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/general/birthday_list', {
        	date_start: this.viewModel.date_start(),
        	date_end: this.viewModel.date_end()
    	});

		if (res.birthdays != null)
		{
			for (let i = 0; i < res.birthdays.length; i++)
			{
				res.birthdays[i].fullName = res.birthdays[i].firstname + ' ' + res.birthdays[i].surname;
			}

			this.viewModel.employee_birthdays(res.birthdays);
		}
		this.viewModel.loader(false);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('UpcomingBirthdaysReport'))
			return;

		document.title = tr('Upcoming Birthdays');
	}
}

export default {
	route: '[/]general/birthdays_report',
	page_class: ReportBirthdayPage,
	template: template,
	template_filename: 'translation/birthday_report'
};
